// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.u5z7ne {
  width: 700px;
  max-width: calc(100vw - 32px);
  border: none;
  border-radius: var(--radius-s, 4px);
  box-shadow: 0 2px 4px rgb(0 0 0 / 12%);
  outline: none;
  overflow: hidden;
  padding: 0;
}

.JDhM6n {
  width: 100%;
  padding: var(--spacing-0-5, 4px);
  box-sizing: border-box;
}

.oLtQtl {
  height: 205px;
  position: relative;
  overflow: hidden;
  border-radius: var(--radius-s, 4px);
}

.Sc7Awc {
  display: block;
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center;
}

.ngiuXV {
  align-items: center;
  background: var(--background-white, #fff);
  border: none;
  border-radius: var(--radius-s, 4px);
  box-shadow: 0 2px 4px rgb(0 0 0 / 12%);
  cursor: pointer;
  display: flex;
  height: 32px;
  justify-content: center;
  line-height: 0;
  margin: 0;
  padding: 0;
  position: absolute;
  right: 24px;
  top: 24px;
  width: 32px;
  z-index: 1;
}

.ngiuXV:hover {
  background: var(--surface-neutral-subtle, #f5f5f5);
}

.ngiuXV:focus-visible {
  outline: 2px solid var(--surface-primary-medium, #d64000);
  outline-offset: 2px;
}

.btKTkf {
  align-items: start;
  background: var(--background-white, #fff);
  box-sizing: border-box;
  display: grid;
  gap: var(--spacing-3, 24px);
  grid-template-columns: minmax(0, 279px) minmax(0, 326px);
  justify-content: center;
  padding: var(--spacing-5, 40px) var(--spacing-3, 24px);
  text-align: left;
  width: 100%;
}

._Mo9BH {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1-5, 12px);
  min-width: 0;
}

.sc4zbj {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1-5, 12px);
}

.QV5LlX {
  align-items: center;
  color: var(--text-neutral-dark, #1f1f1f);
  display: flex;
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-size: var(--font-size-md, 14px);
  font-weight: var(--font-weight-regular, 400);
  gap: 4px;
  height: 23px;
  line-height: 21px;
  white-space: nowrap;
}

.QV5LlX strong {
  font-weight: var(--font-weight-bold, 700);
}

.bMMHO4 {
  color: #000;
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-size: var(--font-size-xl, 20px);
  font-weight: var(--font-weight-semibold, 600);
  line-height: normal;
  margin: 0;
}

.yiZaBR {
  color: var(--text-neutral-dark, #1f1f1f);
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-size: var(--font-size-md, 14px);
  font-weight: var(--font-weight-regular, 400);
  line-height: var(--line-height-180, 1.8);
  margin: 0;
}

.t2cvdR {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2, 16px);
  width: 100%;
}

.ZdPOci {
  height: 40px;
  min-height: 40px;
  width: 100%;
}

.dLZ2tU.dLZ2tU {
  border-width: 0;
  height: 24px;
  min-height: 24px;
  padding: 0;
  width: 100%;
}

.tsSmzp {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2, 16px);
  min-width: 0;
}

.l6SIRA {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1-5, 12px);
}

.RM7qgR {
  align-items: center;
  background: var(--interactive-background-strong, #ededed);
  border-radius: var(--radius-m, 8px);
  box-sizing: border-box;
  display: flex;
  gap: var(--spacing-1-5, 12px);
  padding: var(--spacing-2, 16px) var(--spacing-1-5, 12px);
}

.YkOX7j {
  align-items: center;
  background: var(--background-white, #fff);
  border-radius: 50%;
  display: flex;
  flex: 0 0 32px;
  height: 32px;
  justify-content: center;
  width: 32px;
}

.YkOX7j img {
  display: block;
}

.lPWKEf {
  color: var(--text-neutral-dark, #1f1f1f);
  flex: 1 1 0;
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-size: 15px;
  font-weight: var(--font-weight-regular, 400);
  line-height: 21px;
  margin: 0;
  min-width: 0;
}

.lPWKEf strong {
  font-weight: var(--font-weight-bold, 700);
}

.ckK6Ev {
  color: var(--text-neutral-dark, #1f1f1f);
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-size: var(--font-size-sm, 12px);
  font-weight: var(--font-weight-regular, 400);
  line-height: 1.6;
  margin: 0;
  text-align: center;
}

.ckK6Ev strong {
  font-weight: var(--font-weight-bold, 700);
}

@media (max-width: 720px) {
  .u5z7ne {
    max-width: calc(100vw - 32px);
    min-width: 0;
    width: calc(100vw - 32px);
  }

  .oLtQtl {
    height: clamp(140px, 45vw, 205px);
  }

  .btKTkf {
    gap: var(--spacing-3, 24px);
    grid-template-columns: minmax(0, 1fr);
    padding: var(--spacing-3, 24px) var(--spacing-2, 16px);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/HappyHolidaysEndOfTheYearRechargeModal/HappyHolidaysEndOfTheYearRechargeModal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,mCAAmC;EACnC,sCAAsC;EACtC,aAAa;EACb,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,YAAY;EACZ,mCAAmC;EACnC,sCAAsC;EACtC,eAAe;EACf,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,yDAAyD;EACzD,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,sBAAsB;EACtB,aAAa;EACb,2BAA2B;EAC3B,wDAAwD;EACxD,uBAAuB;EACvB,sDAAsD;EACtD,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,iEAAiE;EACjE,oCAAoC;EACpC,4CAA4C;EAC5C,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,iEAAiE;EACjE,oCAAoC;EACpC,6CAA6C;EAC7C,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,wCAAwC;EACxC,iEAAiE;EACjE,oCAAoC;EACpC,4CAA4C;EAC5C,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,yDAAyD;EACzD,mCAAmC;EACnC,sBAAsB;EACtB,aAAa;EACb,6BAA6B;EAC7B,wDAAwD;AAC1D;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,WAAW;EACX,iEAAiE;EACjE,eAAe;EACf,4CAA4C;EAC5C,iBAAiB;EACjB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;EACxC,iEAAiE;EACjE,oCAAoC;EACpC,4CAA4C;EAC5C,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE;IACE,6BAA6B;IAC7B,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,2BAA2B;IAC3B,qCAAqC;IACrC,sDAAsD;EACxD;AACF","sourcesContent":[".modal {\n  width: 700px;\n  max-width: calc(100vw - 32px);\n  border: none;\n  border-radius: var(--radius-s, 4px);\n  box-shadow: 0 2px 4px rgb(0 0 0 / 12%);\n  outline: none;\n  overflow: hidden;\n  padding: 0;\n}\n\n.body {\n  width: 100%;\n  padding: var(--spacing-0-5, 4px);\n  box-sizing: border-box;\n}\n\n.header {\n  height: 205px;\n  position: relative;\n  overflow: hidden;\n  border-radius: var(--radius-s, 4px);\n}\n\n.headerImage {\n  display: block;\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n  object-position: center;\n}\n\n.closeButton {\n  align-items: center;\n  background: var(--background-white, #fff);\n  border: none;\n  border-radius: var(--radius-s, 4px);\n  box-shadow: 0 2px 4px rgb(0 0 0 / 12%);\n  cursor: pointer;\n  display: flex;\n  height: 32px;\n  justify-content: center;\n  line-height: 0;\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  right: 24px;\n  top: 24px;\n  width: 32px;\n  z-index: 1;\n}\n\n.closeButton:hover {\n  background: var(--surface-neutral-subtle, #f5f5f5);\n}\n\n.closeButton:focus-visible {\n  outline: 2px solid var(--surface-primary-medium, #d64000);\n  outline-offset: 2px;\n}\n\n.content {\n  align-items: start;\n  background: var(--background-white, #fff);\n  box-sizing: border-box;\n  display: grid;\n  gap: var(--spacing-3, 24px);\n  grid-template-columns: minmax(0, 279px) minmax(0, 326px);\n  justify-content: center;\n  padding: var(--spacing-5, 40px) var(--spacing-3, 24px);\n  text-align: left;\n  width: 100%;\n}\n\n.leftColumn {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1-5, 12px);\n  min-width: 0;\n}\n\n.intro {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1-5, 12px);\n}\n\n.eyebrow {\n  align-items: center;\n  color: var(--text-neutral-dark, #1f1f1f);\n  display: flex;\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-size: var(--font-size-md, 14px);\n  font-weight: var(--font-weight-regular, 400);\n  gap: 4px;\n  height: 23px;\n  line-height: 21px;\n  white-space: nowrap;\n}\n\n.eyebrow strong {\n  font-weight: var(--font-weight-bold, 700);\n}\n\n.title {\n  color: #000;\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-size: var(--font-size-xl, 20px);\n  font-weight: var(--font-weight-semibold, 600);\n  line-height: normal;\n  margin: 0;\n}\n\n.description {\n  color: var(--text-neutral-dark, #1f1f1f);\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-size: var(--font-size-md, 14px);\n  font-weight: var(--font-weight-regular, 400);\n  line-height: var(--line-height-180, 1.8);\n  margin: 0;\n}\n\n.actions {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2, 16px);\n  width: 100%;\n}\n\n.primaryButton {\n  height: 40px;\n  min-height: 40px;\n  width: 100%;\n}\n\n.textButton.textButton {\n  border-width: 0;\n  height: 24px;\n  min-height: 24px;\n  padding: 0;\n  width: 100%;\n}\n\n.detailsColumn {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2, 16px);\n  min-width: 0;\n}\n\n.benefitCards {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1-5, 12px);\n}\n\n.benefitCard {\n  align-items: center;\n  background: var(--interactive-background-strong, #ededed);\n  border-radius: var(--radius-m, 8px);\n  box-sizing: border-box;\n  display: flex;\n  gap: var(--spacing-1-5, 12px);\n  padding: var(--spacing-2, 16px) var(--spacing-1-5, 12px);\n}\n\n.benefitIcon {\n  align-items: center;\n  background: var(--background-white, #fff);\n  border-radius: 50%;\n  display: flex;\n  flex: 0 0 32px;\n  height: 32px;\n  justify-content: center;\n  width: 32px;\n}\n\n.benefitIcon img {\n  display: block;\n}\n\n.benefitCopy {\n  color: var(--text-neutral-dark, #1f1f1f);\n  flex: 1 1 0;\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-size: 15px;\n  font-weight: var(--font-weight-regular, 400);\n  line-height: 21px;\n  margin: 0;\n  min-width: 0;\n}\n\n.benefitCopy strong {\n  font-weight: var(--font-weight-bold, 700);\n}\n\n.termsNotice {\n  color: var(--text-neutral-dark, #1f1f1f);\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-size: var(--font-size-sm, 12px);\n  font-weight: var(--font-weight-regular, 400);\n  line-height: 1.6;\n  margin: 0;\n  text-align: center;\n}\n\n.termsNotice strong {\n  font-weight: var(--font-weight-bold, 700);\n}\n\n@media (max-width: 720px) {\n  .modal {\n    max-width: calc(100vw - 32px);\n    min-width: 0;\n    width: calc(100vw - 32px);\n  }\n\n  .header {\n    height: clamp(140px, 45vw, 205px);\n  }\n\n  .content {\n    gap: var(--spacing-3, 24px);\n    grid-template-columns: minmax(0, 1fr);\n    padding: var(--spacing-3, 24px) var(--spacing-2, 16px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `u5z7ne`,
	"body": `JDhM6n`,
	"header": `oLtQtl`,
	"headerImage": `Sc7Awc`,
	"closeButton": `ngiuXV`,
	"content": `btKTkf`,
	"leftColumn": `_Mo9BH`,
	"intro": `sc4zbj`,
	"eyebrow": `QV5LlX`,
	"title": `bMMHO4`,
	"description": `yiZaBR`,
	"actions": `t2cvdR`,
	"primaryButton": `ZdPOci`,
	"textButton": `dLZ2tU`,
	"detailsColumn": `tsSmzp`,
	"benefitCards": `l6SIRA`,
	"benefitCard": `RM7qgR`,
	"benefitIcon": `YkOX7j`,
	"benefitCopy": `lPWKEf`,
	"termsNotice": `ckK6Ev`
};
module.exports = ___CSS_LOADER_EXPORT___;
